<template>
  <el-select
    v-model="advVal"
    placeholder="请选择"
    class="custom_form"
    :popper-append-to-body="false"
    popper-class="form_pop"
  >
    <el-option
      class="adv_opt"
      v-for="item in optsAdvTime"
      :key="item.guid"
      :label="item.dictItemName + '秒'"
      :value="item.dictItemName">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'MySearchSelectAdvTime',
  props: {
    value: {
      type: String,
      default: '5'
    }
  },
  computed: {
    // optsAdvTime () {
    //   return this.$store.state.bmap.labelTimeSlotList
    //   // return this.$store.state.common.ADVERTSLOTTIME
    // },
    advVal: {
      get () {
        return this.value
      },
      set (nv) {
        this.$emit('input', nv)
      }
    }
  },
  data () {
    return {
      optsAdvTime: []
    }
  },
  watch: {
    optsAdvTime: {
      immediate: true,
      handler (nv) {
        if (nv.length > 0 && !this.value) {
          this.advVal = nv[0].dictItemName
          let defaultCotentTime = nv.filter(el => el.default)[0] // 默认
          if (defaultCotentTime) this.advVal = defaultCotentTime.dictItemName
        }
      }
    }
  },
  async created () {
    this.optsAdvTime = await this.getContentTimes()
  },
  methods: {
    async getContentTimes () { // 获取购买时长列表
      if (!this.$store.state.bmap.labelTimeSlotList.length) await this.$store.dispatch('getTimeSlotList')
      return this.$store.state.bmap.labelTimeSlotList || []
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  display: block;
  margin-right: 10px;
  ::v-deep .el-input__inner {
    border-color: transparent !important;
  }
}
.adv_opt.selected {
  color: #FF3973;
  &::after {
    content: '✓';
    color: #FF3973;
    float: right;
  }
}
</style>
